export const html = "<p>Try the beloved ponchik in Gyumri.</p>\n";
export const leadHtml = "<p>Try the beloved ponchik in Gyumri.</p>\n";
export const bodyHtml = "";
export const metaText = "Try the beloved ponchik in Gyumri.";